module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Magic is only as black as the heart that practices it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "epc-I"
  }, [_vm._v("Abramo Fiorentino")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Real magic is the transformation of self.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC-NOBOT"
  }, [_c('span', {
    staticClass: "epc-I"
  }, [_vm._v("J.M. Dillard")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0